import ApiProvider from 'API_LAYER/ApiProvider'
import { createTokenRefreshingAxiosInstance } from 'API_LAYER/refreshToken'
import axios from 'axios'
import equal from 'fast-deep-equal'
import * as Actions from 'infra/redux/actions'
import _ from 'lodash'
import * as API from '../API_LAYER'
import * as Config from './Config'
import FeatureFlags from './FeatureFlagClass'
import Theme from './Theme'

export { default as PropTypes } from 'prop-types'
export { Component, default as React } from 'react'
export { connect, Provider, useDispatch, useSelector } from 'react-redux'
export { Link, NavLink, Prompt, Redirect, Route, Switch, withRouter } from 'react-router-dom'
export { combineReducers } from 'redux'
export { _, Actions, API, ApiProvider, Config, Theme }
/** Feature Flag Object can return flags | flags Can be updated as well */
const FeatureFlagsObject = new FeatureFlags()
export { FeatureFlagsObject }

// Enable queuing
// am4core.options.queue = true
// am4core.options.autoDispose = true

String.prototype.replaceAll = function (search, replacement) {
  try {
    var target = this
    if (!search) return ''
    return target.replace(new RegExp(search, 'g'), replacement)
  } catch (error) {
    return ''
  }
}

const axInstance = createTokenRefreshingAxiosInstance(axios.create())

export { axInstance as axios }

export { equal as fastEqual }
